import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const App = lazy(() => import("./App"))
const Login = lazy(() => import("./Login"))
const Data = lazy(() => import("./Data"))

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/Login",
    element: <Login />,
  },
  {
    path: "/data",
    element: <Data />
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={"Loading ...."}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>
);